import { defineComponent as t, openBlock as l, createBlock as a, unref as p, mergeProps as s, withCtx as c, createElementVNode as o } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconCrossInCircle",
  __name: "IconCrossInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const r = n;
    return (d, e) => (l(), a(p(i), s(r, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        o("path", { d: "M8.53 7.47a.75.75 0 0 0-1.06 1.06L10.94 12l-3.47 3.47a.75.75 0 1 0 1.06 1.06L12 13.06l3.47 3.47a.75.75 0 1 0 1.06-1.06L13.06 12l3.47-3.47a.75.75 0 0 0-1.06-1.06L12 10.94 8.53 7.47" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
